import { updateSettingsServiceApi as generatedUpdateSettingsServiceApi } from '../generated/settingsServices/updateSettingsService';

const updateSettingsServiceApi = generatedUpdateSettingsServiceApi.enhanceEndpoints({
  endpoints: {
    updateSettingsService: {
      invalidatesTags: (_result, _error, { serviceId }) => [{ id: serviceId, type: 'Services' }, 'Services'],
    },
  },
});

export const { useUpdateSettingsServiceMutation } = updateSettingsServiceApi;
